import { createFileRoute } from '@tanstack/react-router'
import WorksGridSearch from 'Work/components/Work/search/WorksGridSearch'

export const Route = createFileRoute('/_worksearch/works')({
    validateSearch: (search: Record<string, string>) => search,
    component: WorksGridSearch,
})
